export default {
  v: '5.7.6',
  fr: 25,
  ip: 0,
  op: 100,
  w: 56,
  h: 56,
  nm: '合成 1',
  ddd: 0,
  assets: [],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 4,
      nm: '“演讲”轮廓',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.52],
                y: [0.96]
              },
              o: {
                x: [0.48],
                y: [0.04]
              },
              t: 45,
              s: [0]
            },
            {
              i: {
                x: [0.52],
                y: [1]
              },
              o: {
                x: [0.48],
                y: [0]
              },
              t: 50,
              s: [100]
            },
            {
              i: {
                x: [0.52],
                y: [0.92]
              },
              o: {
                x: [0.48],
                y: [0.08]
              },
              t: 75,
              s: [100]
            },
            {
              t: 85,
              s: [0]
            }
          ],
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [20.25, 28, 0],
          ix: 2,
          l: 2
        },
        a: {
          a: 0,
          k: [354.5, 316.5, 0],
          ix: 1,
          l: 2
        },
        s: {
          a: 0,
          k: [3, 3, 100],
          ix: 6,
          l: 2
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [97.676, 60.11],
                    [21.809, 16.668],
                    [22.496, -15.73],
                    [-8.172, -26.203],
                    [-27.449, -0.161],
                    [-10.238, 6.5],
                    [2.504, -29.641],
                    [0, 0],
                    [0, 0],
                    [23.488, 23.484],
                    [33.211, 0],
                    [0, 0],
                    [23.484, -23.485],
                    [0, -33.211],
                    [0, 0],
                    [-6.653, -6.656],
                    [-9.41, 0],
                    [0, 0],
                    [0, 19.593],
                    [0, 0],
                    [13.981, 5.851]
                  ],
                  o: [
                    [6.68, -77.223],
                    [9.269, -25.836],
                    [-21.808, -16.664],
                    [-22.493, 15.73],
                    [8.172, 26.207],
                    [12.125, -0.043],
                    [100.18, 56.77],
                    [0, 0],
                    [0, 0],
                    [0, -33.211],
                    [-23.484, -23.485],
                    [0, 0],
                    [-33.211, 0],
                    [-23.485, 23.484],
                    [0, 0],
                    [0, 9.41],
                    [6.656, 6.653],
                    [0, 0],
                    [19.593, 0],
                    [0, 0],
                    [0.996, -15.125],
                    [0, 0]
                  ],
                  v: [
                    [332.438, 138.256],
                    [224.325, -133.069],
                    [203.27, -204.44],
                    [128.876, -206.01],
                    [104.825, -135.596],
                    [164.633, -91.326],
                    [198.864, -101.346],
                    [290.696, 133.666],
                    [227.665, 133.666],
                    [227.665, 48.092],
                    [190.985, -40.455],
                    [102.438, -77.135],
                    [-228.995, -77.135],
                    [-317.542, -40.455],
                    [-354.222, 48.092],
                    [-354.222, 186.26],
                    [-343.831, 211.349],
                    [-318.742, 221.74],
                    [318.665, 221.74],
                    [354.145, 186.26],
                    [354.145, 173.318],
                    [332.438, 138.256]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [354.222, 411.26],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: '变换'
            }
          ],
          nm: '组 1',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        },
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-75.613, 0],
                    [0, 75.617],
                    [75.618, 0],
                    [0, -75.618]
                  ],
                  o: [
                    [0, 75.617],
                    [75.618, 0],
                    [0, -75.618],
                    [-75.613, 0],
                    [0, 0]
                  ],
                  v: [
                    [-136.916, 0],
                    [-0.002, 136.914],
                    [136.916, 0],
                    [-0.002, -136.914],
                    [-136.916, 0]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'fl',
              c: {
                a: 0,
                k: [1, 1, 1, 1],
                ix: 4
              },
              o: {
                a: 0,
                k: 100,
                ix: 5
              },
              r: 1,
              bm: 0,
              nm: '填充 1',
              mn: 'ADBE Vector Graphic - Fill',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [291.361, 137.102],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: '变换'
            }
          ],
          nm: '组 2',
          np: 4,
          cix: 2,
          bm: 0,
          ix: 2,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 0,
      op: 100,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 3,
      ty: 4,
      nm: '角',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [28, 28, 0],
          ix: 2,
          l: 2
        },
        a: {
          a: 0,
          k: [28, 28, 0],
          ix: 1,
          l: 2
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
          l: 2
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [-0.161, 0.032],
                    [-0.093, -0.14],
                    [0, -0.183],
                    [0, 0],
                    [0, 0],
                    [0.096, -0.146],
                    [0.161, -0.068],
                    [0.158, 0.032],
                    [0.121, 0.122],
                    [0, 0],
                    [0, 0],
                    [0, 0.229],
                    [-0.173, 0.175],
                    [0, 0],
                    [0, 0]
                  ],
                  o: [
                    [0.642, 0.116],
                    [0.096, 0.146],
                    [0, 0],
                    [0, 0],
                    [0, 0.183],
                    [-0.093, 0.141],
                    [-0.155, 0.065],
                    [-0.161, -0.032],
                    [0, 0],
                    [0, 0],
                    [-0.174, -0.176],
                    [0, -0.23],
                    [0, 0],
                    [0, 0],
                    [0.121, -0.123]
                  ],
                  v: [
                    [20.485, -9.436],
                    [21.351, -9.066],
                    [21.5, -8.565],
                    [21.5, -8.565],
                    [21.5, 8.564],
                    [21.351, 9.066],
                    [20.966, 9.388],
                    [20.485, 9.436],
                    [20.052, 9.201],
                    [20.052, 9.201],
                    [11.615, 0.636],
                    [11.357, 0],
                    [11.614, -0.636],
                    [11.614, -0.636],
                    [20.052, -9.2]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: '路径 2',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 1,
              nm: '合并路径 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'st',
              c: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.52],
                      y: [0.933]
                    },
                    o: {
                      x: [0.48],
                      y: [0.067]
                    },
                    t: 25,
                    s: [0.099044687608, 0.061496192334, 0.22466840557, 1]
                  },
                  {
                    i: {
                      x: [0.807],
                      y: [1]
                    },
                    o: {
                      x: [0.391],
                      y: [0]
                    },
                    t: 30,
                    s: [1, 1, 1, 1]
                  },
                  {
                    i: {
                      x: [1],
                      y: [1]
                    },
                    o: {
                      x: [0.631],
                      y: [0]
                    },
                    t: 75,
                    s: [1, 1, 1, 1]
                  },
                  {
                    t: 85,
                    s: [0.098039217293, 0.06274510175, 0.223529413342, 1]
                  }
                ],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 3,
                ix: 5
              },
              lc: 1,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: '描边 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [28, 28.333],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: '变换'
            }
          ],
          nm: '组 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        }
      ],
      ip: 0,
      op: 100,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 4,
      ty: 4,
      nm: '方',
      sr: 1,
      ks: {
        o: {
          a: 0,
          k: 100,
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [28, 28, 0],
          ix: 2,
          l: 2
        },
        a: {
          a: 0,
          k: [28, 28, 0],
          ix: 1,
          l: 2
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
          l: 2
        }
      },
      ao: 0,
      shapes: [
        {
          ty: 'gr',
          it: [
            {
              ind: 0,
              ty: 'sh',
              ix: 1,
              ks: {
                a: 0,
                k: {
                  i: [
                    [0, 0],
                    [-0.551, -0.552],
                    [0, -1.079],
                    [0, 0],
                    [0, 0],
                    [0.552, -0.554],
                    [1.072, 0],
                    [0, 0],
                    [0, 0],
                    [0.55, 0.553],
                    [0, 1.079],
                    [0, 0],
                    [0, 0],
                    [-0.552, 0.554],
                    [-1.072, 0],
                    [0, 0]
                  ],
                  o: [
                    [1.072, 0],
                    [0.552, 0.554],
                    [0, 0],
                    [0, 0],
                    [0, 1.079],
                    [-0.551, 0.553],
                    [0, 0],
                    [0, 0],
                    [-1.072, 0],
                    [-0.552, -0.554],
                    [0, 0],
                    [0, 0],
                    [0, -1.079],
                    [0.55, -0.552],
                    [0, 0],
                    [0, 0]
                  ],
                  v: [
                    [2.948, -13.833],
                    [5.425, -13.091],
                    [6.167, -10.598],
                    [6.167, -10.598],
                    [6.167, 10.598],
                    [5.425, 13.09],
                    [2.948, 13.833],
                    [2.948, 13.833],
                    [-18.282, 13.833],
                    [-20.758, 13.09],
                    [-21.5, 10.598],
                    [-21.5, 10.598],
                    [-21.5, -10.598],
                    [-20.758, -13.091],
                    [-18.282, -13.833],
                    [-18.282, -13.833]
                  ],
                  c: true
                },
                ix: 2
              },
              nm: '路径 1',
              mn: 'ADBE Vector Shape - Group',
              hd: false
            },
            {
              ty: 'mm',
              mm: 1,
              nm: '合并路径 1',
              mn: 'ADBE Vector Filter - Merge',
              hd: false
            },
            {
              ty: 'st',
              c: {
                a: 1,
                k: [
                  {
                    i: {
                      x: [0.52],
                      y: [0.933]
                    },
                    o: {
                      x: [0.48],
                      y: [0.067]
                    },
                    t: 25,
                    s: [0.099044687608, 0.061496192334, 0.22466840557, 1]
                  },
                  {
                    i: {
                      x: [0.52],
                      y: [-138.029]
                    },
                    o: {
                      x: [0.48],
                      y: [0]
                    },
                    t: 30,
                    s: [1, 1, 1, 1]
                  },
                  {
                    i: {
                      x: [0.52],
                      y: [1.134]
                    },
                    o: {
                      x: [0.48],
                      y: [0]
                    },
                    t: 75,
                    s: [1, 1, 1, 1]
                  },
                  {
                    t: 85,
                    s: [0.098039217293, 0.06274510175, 0.223529413342, 1]
                  }
                ],
                ix: 3
              },
              o: {
                a: 0,
                k: 100,
                ix: 4
              },
              w: {
                a: 0,
                k: 3,
                ix: 5
              },
              lc: 2,
              lj: 1,
              ml: 4,
              bm: 0,
              nm: '描边 1',
              mn: 'ADBE Vector Graphic - Stroke',
              hd: false
            },
            {
              ty: 'tr',
              p: {
                a: 0,
                k: [28, 28.333],
                ix: 2
              },
              a: {
                a: 0,
                k: [0, 0],
                ix: 1
              },
              s: {
                a: 0,
                k: [100, 100],
                ix: 3
              },
              r: {
                a: 0,
                k: 0,
                ix: 6
              },
              o: {
                a: 0,
                k: 100,
                ix: 7
              },
              sk: {
                a: 0,
                k: 0,
                ix: 4
              },
              sa: {
                a: 0,
                k: 0,
                ix: 5
              },
              nm: '变换'
            }
          ],
          nm: '组 1',
          np: 3,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: 'ADBE Vector Group',
          hd: false
        },
        {
          ty: 'tm',
          s: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.52],
                  y: [1]
                },
                o: {
                  x: [0.48],
                  y: [0]
                },
                t: 25,
                s: [0]
              },
              {
                i: {
                  x: [0.52],
                  y: [1]
                },
                o: {
                  x: [0.48],
                  y: [0]
                },
                t: 50,
                s: [0]
              },
              {
                t: 75,
                s: [100]
              }
            ],
            ix: 1
          },
          e: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.52],
                  y: [0.952]
                },
                o: {
                  x: [0.48],
                  y: [0.048]
                },
                t: 25,
                s: [100]
              },
              {
                i: {
                  x: [0.52],
                  y: [1.112]
                },
                o: {
                  x: [0.48],
                  y: [-0.112]
                },
                t: 50,
                s: [30]
              },
              {
                t: 75,
                s: [0]
              }
            ],
            ix: 2
          },
          o: {
            a: 1,
            k: [
              {
                i: {
                  x: [0.658],
                  y: [0.988]
                },
                o: {
                  x: [0.486],
                  y: [0.017]
                },
                t: 25,
                s: [0]
              },
              {
                i: {
                  x: [0.52],
                  y: [0.949]
                },
                o: {
                  x: [0.48],
                  y: [0.051]
                },
                t: 50,
                s: [360]
              },
              {
                t: 75,
                s: [240]
              }
            ],
            ix: 3
          },
          m: 1,
          ix: 2,
          nm: '修剪路径 1',
          mn: 'ADBE Vector Filter - Trim',
          hd: false
        }
      ],
      ip: 0,
      op: 100,
      st: 0,
      bm: 0
    },
    {
      ddd: 0,
      ind: 5,
      ty: 4,
      nm: '形状图层 1',
      sr: 1,
      ks: {
        o: {
          a: 1,
          k: [
            {
              i: {
                x: [0.52],
                y: [0.96]
              },
              o: {
                x: [0.48],
                y: [0.04]
              },
              t: 25,
              s: [0]
            },
            {
              i: {
                x: [0.52],
                y: [1]
              },
              o: {
                x: [0.48],
                y: [0]
              },
              t: 30,
              s: [100]
            },
            {
              i: {
                x: [0.52],
                y: [0.96]
              },
              o: {
                x: [0.48],
                y: [0.04]
              },
              t: 75,
              s: [100]
            },
            {
              t: 85,
              s: [0]
            }
          ],
          ix: 11
        },
        r: {
          a: 0,
          k: 0,
          ix: 10
        },
        p: {
          a: 0,
          k: [28, 28, 0],
          ix: 2,
          l: 2
        },
        a: {
          a: 0,
          k: [0, 0, 0],
          ix: 1,
          l: 2
        },
        s: {
          a: 0,
          k: [100, 100, 100],
          ix: 6,
          l: 2
        }
      },
      ao: 0,
      shapes: [
        {
          d: 1,
          ty: 'el',
          s: {
            a: 0,
            k: [56, 56],
            ix: 2
          },
          p: {
            a: 0,
            k: [0, 0],
            ix: 3
          },
          nm: '椭圆路径 1',
          mn: 'ADBE Vector Shape - Ellipse',
          hd: false
        },
        {
          ty: 'fl',
          c: {
            a: 0,
            k: [0, 0.537254929543, 1, 1],
            ix: 4
          },
          o: {
            a: 0,
            k: 100,
            ix: 5
          },
          r: 1,
          bm: 0,
          nm: '填充 1',
          mn: 'ADBE Vector Graphic - Fill',
          hd: false
        }
      ],
      ip: 0,
      op: 100,
      st: 0,
      bm: 0
    }
  ],
  markers: []
}
